<template>
  <a-modal 
    :visible="visible" 
    :title="title"
    :width="800"
    :forceRender="true"
    @ok="ok"
    @cancel="cancel"
    destroyOnClose
  > 

    <p v-if="list.length > 0" style="font-weight: bold;font-size: 12px;color: #333;"><span style="color: red;margin-right: 5px;">*</span>关联工厂</p>
    <a-table
      v-if="list.length > 0"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :row-selection="rowSelection"
      :scroll="{y: 200}"
      row-key="factoryId"
    >
      <template slot="tooltip" slot-scope="text">
        <a-tooltip>
          <template slot="title">
            {{text}}
          </template>
          {{text}}
        </a-tooltip>
      </template>
    </a-table>
    <a-form :form="form" layout="vertical" class="pushEbsStyle" v-if="isShowReason">
      <a-form-item :label='labelTitle'>
        <a-checkbox-group
          v-decorator="['reasonArr', { rules: [{ required: true, message: '请选择本次配方调整原因' }] }]"
        >
          <a-checkbox v-for="el in reasonList" :key="el.id" :value="el.dictKey">{{el.dictValue}}</a-checkbox>
        </a-checkbox-group>
      </a-form-item>
      <a-form-item label="原因描述">
        <a-textarea
          v-decorator="['reasonDescribe']"
          placeholder="请输入"
          :auto-size="{ minRows: 3, maxRows: 5 }"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  props: ['visible','productIds','reasonList','version','selfFactoryId'],
  data() {
    return {
      title: <p>推送EBS<span class='modalTitle'></span></p>,
      labelTitle: <span style={{fontWeight: 'bold'}}>本次配方调整原因</span>,
      form: this.$form.createForm(this),
      list: [],
      columns: [
        {
          title: '组织名称',
          dataIndex: 'name',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'tooltip' },
        },
        {
          title: '组织编号',
          dataIndex: 'code',
          width: 90,
          ellipsis: true,
        },
        {
          title: 'EBS实体编码',
          dataIndex: 'ebsEntityCode',
          width: 90,
          ellipsis: true,
        },
        {
          title: 'EBS库存名称',
          dataIndex: 'ebsMaterialName',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'tooltip' },
        },
        {
          title: 'EBS库存编码',
          dataIndex: 'ebsMaterialCode',
          width: 90,
          ellipsis: true,
        },
      ],
      pagination: {
        total:0,
        pageSize:20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      selectedRowKeys:[],
    }
  },
  watch: {
    visible(val){
      if(val) {
        this.selectedRowKeys = []
        this.getLinkList()
      }
    }
  },
  computed:{
    rowSelection(){
      return{
        type: 'radio',
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys
        },
        selectedRowKeys:this.selectedRowKeys
      }
    },
    isShowReason(){
      return this.version != 1
    }
  },
  methods:{
    getLinkList(){
      // const res = await this.fetchGet({
      //   actions:this.subFactoryList,
      //   isList:true,
      //   data:{
      //     factoryId: window.localStorage.getItem('factoryId')
      //   }
      // })
      let params = {
        factoryId: window.localStorage.getItem('factoryId')
      }
      this.$http.get('/iot-factory/factorysublink/subFactoryList',{params}).then(res => {
        let {data,success} = res || {}
        if(success) {
          this.list = data || []
          console.log(data[0].factoryId)
          if(data && data.length > 0) this.selectedRowKeys = [data[0].factoryId] || []
        }
      })
    },
    ok(){
      let isSelf = false
      if(this.list.length > 0 && this.selectedRowKeys.length === 0){
        this.$message.warning('请选择配方关联工厂')
        return
      }
      if(this.selectedRowKeys.length === 0){
        isSelf = true
      }
      this.form.validateFields((err,values) => {
        if(!err){
          // this.$emit('close', false);
          let {reasonArr=[]} = values || {}
          let pushEbsReason = reasonArr.join(',')
          let data = {
            ...values,pushEbsReason,productIds: this.productIds.join(','),
          }
          this.$http.post('/nhf-app/formulaproductpebsreason/batchSavePebsReason',data).then(res => {
            let {success,msg} = res || {}
            let feild = 'warning'
            if(success) feild = 'success'
            this.$message[feild](msg)
            this.$emit('close', {type: true,ebsPushFactoryId: isSelf ? this.selfFactoryId : this.selectedRowKeys[0]});
          })
        }
      })
    },
    cancel(){
      this.$emit('close', false);
    },
  }
}
</script>
<style lang="scss">
  .pushEbsStyle{
    margin-top: 20px;
    .ant-checkbox-wrapper + .ant-checkbox-wrapper{
      margin-left: 0;
    }
  }
</style>